jQuery(document).ready(function () {
    window.dataMethodUrl("btn-method-table-delete", function (response) {
        if (response && response.reload) {
            location.reload();
            return;
        }

        jQuery(this).closest("tr").fadeOut(300, function () {
            jQuery(this).remove();
        });

        let message = (response && response.message)
            ? response.message
            : "Успешно удалено";
        window.showToast(message, "success");
    });
});
